export const validateUrl = (value) => {
    if (!value) {
        return false;
    }
    const regex =
        /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]+(\.[a-zA-Z0-9]{2,})+([/a-zA-Z0-9]*)(\?[a-zA-Z0-9=&]*)?$/;

    return regex.test(value);
};
